module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "ql-page",
    attrs: {
      "id": "ql-page"
    }
  }, [_c('md-dialog', {
    ref: "no-layers-dialog",
    attrs: {
      "md-open-from": ("cardCover" + _vm.pageNumber),
      "md-close-to": ("cardCover" + _vm.pageNumber)
    }
  }, [_c('md-dialog-title', [_vm._v("You don't have a current layer!")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("Open up the layers menu and choose a layer to edit.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.closeDialog('no-layers-dialog')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-card-media-cover', {
    ref: "cardCover",
    staticClass: "ql-page-cover",
    attrs: {
      "id": ("cardCover" + _vm.pageNumber)
    }
  }, [(_vm.ready) ? _c('project-pdf-page', {
    staticClass: "ql-pdf-page",
    class: {
      'night-mode': _vm.showMode, 'disable-text': _vm.disableText
    },
    attrs: {
      "page": _vm.page,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight
    },
    on: {
      "pdfLoaded": _vm.pdfLoaded,
      "rightclick": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.rightClick($event)
      },
      "cueCreated": _vm.cueCreated
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('p', [_vm._v("Loading PDF...")]) : _vm._e(), _vm._v(" "), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "marker-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, [_vm._l((_vm.positionCues), function(cue) {
    return _c('cue-position-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": _vm.isCueEditable(cue),
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateCue": _vm.updateCue,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.selectionCues), function(cue) {
    return _c('cue-selection-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": _vm.isCueEditable(cue),
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateCue": _vm.updateCue,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.addingCue) ? _c('project-cues-add-cue-button', {
    staticClass: "ql-add-cue-button",
    style: ({
      top: (_vm.addCueY + "px"),
      left: (_vm.addCueX + "px")
    }),
    attrs: {
      "cueToAdd": _vm.cueToAdd
    },
    on: {
      "cancel": _vm.cancelAddCue,
      "addText": _vm.addText,
      "addCue": _vm.addCue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "ql-note-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, _vm._l((_vm.displayNotes), function(note) {
    return _c('project-note', {
      key: ("" + (note.id) + _vm.versionID),
      attrs: {
        "note": note,
        "locked": !_vm.isNoteEditable(note) || _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateNote": _vm.updateNote,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cba74f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/page.vue
// module id = 642
// module chunks = 2